module.exports = __webpack_public_path__ + "static/media/fah_eu.9df559fb.jpeg";